import axios from "axios";
import {materialCloudServicesPath} from "../../../Constants";

const restUrl =materialCloudServicesPath + '/user/suppliers'

export default class MaterialCloudSuppliers {
    static async get() {
        return axios.get(`${restUrl}`);
    }
}